import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TeamsContainer from "../containers/teams/TeamsContainer";
import { languages } from "../constants/languages";
import { withWidth } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

class ParticipantsTabs extends React.Component {
  state = {
    value: 0,
  };

  componentDidMount = () => {
    if (this.props.index) {
      this.setState({ value: this.props.index });
    }
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.prosoccerdata) {
      fetch("https://tournify-server.herokuapp.com/requestPsdCodeUpgrade", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          psdCode: this.props.tournament.crqpsd || "",
          tournamentId: this.props.tournament[".key"],
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (payload) {
          // let status = payload.status;
          // console.log(status);
        });
    }
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return this.props.tournamentAdmin === undefined ||
      this.props.tournamentAdmin.manageTeams ? (
      <div style={{ width: "100%" }}>
        <Paper style={{ maxWidth: 650, margin: "0 auto 35px" }}>
          <Tabs
            centered={this.props.width !== "xs"}
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant={this.props.width === "xs" ? "scrollable" : "standard"}
            scrollButtons="off"
          >
            <Tab
              key={0}
              label={
                this.props.tournament.individualPlayers
                  ? languages.teams.players
                  : languages.tournament.teams
              }
            />
            <Tab
              key={1}
              label={
                this.props.tournament.useJudges
                  ? languages.referees.judges
                  : languages.schedule.referees
              }
            />
            {this.props.tournamentAdmin === undefined && (
              <Tab key={2} label={languages.admins.admins} />
            )}
          </Tabs>
        </Paper>
        <div style={{ display: this.state.value === 0 ? "initial" : "none" }}>
          <TeamsContainer {...this.props} />
        </div>
        <div style={{ display: this.state.value === 1 ? "initial" : "none" }}>
          <TeamsContainer {...this.props} refereesPage />
        </div>
        {this.props.tournamentAdmin === undefined && (
          <div style={{ display: this.state.value === 2 ? "initial" : "none" }}>
            <TeamsContainer {...this.props} adminsPage />
          </div>
        )}
      </div>
    ) : (
      <div />
    );
  }
}

export default withWidth()(ParticipantsTabs);
